import React, { useEffect, Fragment, useCallback, useState } from 'react';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ModalSetupCall(props) {
    const {
        modalSetupCall,
        toggleModalSetupCall,
        modalScheduleCall,
        toggleModalScheduleCall,
        modallCallPlan,
        toggleModallCallPlan,
        allPlans
    } = props;
    const [receivers, setReceivers] = useState([]);
    const [plan, setPlan] = useState(null);
    const { currentGroup, toggleLoading, setGlobalUpdate } = useAuth();
    const [optionSelectPlan, setOptionSelectPlan] = useState(false);
    const [isLoadingReceivers, setIsLoadingReceivers] = useState(false);

    const [enabledRecurringScheduleCall, setEnabledRecurringScheduleCall] = useState(false);
    const [recurringScheduleCallNumber, setRecurringScheduleCallNumber] = useState(1);

    const loadReceivers = useCallback(() => {
        setIsLoadingReceivers(true);
        api.post(`/ro.team.listGiverToReceiverForGiver/${currentGroup.id}`)
            .then((response) => {
                setReceivers(response.data.items);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                setIsLoadingReceivers(false);
            });
    }, [currentGroup.id, setIsLoadingReceivers]);

    useEffect(() => {
        loadReceivers();
    }, [loadReceivers]);

    const triggerScheduleCall = useCallback(() => {
        setEnabledRecurringScheduleCall(false);
        setRecurringScheduleCallNumber(1);
        
        toggleModalSetupCall();
        toggleModalScheduleCall();
    }, [toggleModalSetupCall, toggleModalScheduleCall, setEnabledRecurringScheduleCall, setRecurringScheduleCallNumber]);

    const triggerCallPlan = useCallback(() => {
        toggleModalSetupCall();
        toggleModallCallPlan();
    }, [toggleModalSetupCall, toggleModallCallPlan]);

    const [date, setDate] = useState(new Date());
    const toggleDate = useCallback(
        (date) => {
            setDate(date);
        },
        [setDate]
    );

    const { register, handleSubmit, reset } = useForm({});

    const onSubmitScheduleCall = useCallback(
        async (data) => {
            if (!data.receiver) {
                return;
            }
            toggleLoading(true);

            try {
                await api.post(`/ro.team.insertScheduleGift`, {
                    receiverId: data.receiver,
                    date: moment(date).format('YMMDDHHmm'),
                    groupId: currentGroup.id,
                });

                if (enabledRecurringScheduleCall && recurringScheduleCallNumber) {
                    for (let i=1;i<=recurringScheduleCallNumber;i++) {
                        await api.post(`/ro.team.insertScheduleGift`, {
                            receiverId: data.receiver,
                            date: moment(date).add(i, 'week').format('YMMDDHHmm'),
                            groupId: currentGroup.id,
                        });
                    }
                }

                toast.success(`Call scheduled`);
                toggleModalScheduleCall();
                reset();
                setGlobalUpdate({scheduledGifts: true});
            } catch(err) {
                // toast.error(err.response.data.message);
                toast.error(`An error ocurred. Please try again!`);
            }

            toggleLoading(false);

            // OLD Request
            // api.post(`/ro.team.insertScheduleGift`, {
            //     receiverId: data.receiver,
            //     date: moment(date).format('YMMDDHHmm'),
            //     groupId: currentGroup.id,
            // })
            //     .then((response) => {
            //         toast.success(`Call scheduled`);
            //         toggleModalScheduleCall();
            //         reset(response);
            //         setGlobalUpdate({scheduledGifts: true});
            //     })
            //     .catch((err) => {
                    
            //     })
            //     .finally(() => {
            //         toggleLoading(false);
            //     });
        },
        [toggleModalScheduleCall, reset, currentGroup, date, toggleLoading, setGlobalUpdate, enabledRecurringScheduleCall, recurringScheduleCallNumber]
    );

    const onSubmitCallPlan = useCallback(
        async (data) => {
            if (plan) {
                toggleLoading(true);
                api.patch(`/ro.team.modifyPlanGift/${plan.id}`, {
                    receiverId: plan.receiver.id,
                    groupId: currentGroup.id,
                    plan: {
                        times: data.plan,
                        times_per: data.timePer,
                        period: data.period,
                    },
                    notes: data.notes,
                })
                    .then((response) => {
                        toast.success(`Call edited!`);
                        toggleModallCallPlan();
                        reset(response);
                        setGlobalUpdate({planList: true});
                    })
                    .catch((err) => {
                        toast.error(err.response.data.message);
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            } else {
                if (data.receiver === '') {
                    toast.error('Select a Senior');
                    return;
                }
                toggleLoading(true);
                api.post('/ro.team.insertPlanGift', {
                    receiverId: data.receiver,
                    groupId: currentGroup.id,
                    plan: {
                        times: data.plan,
                        times_per: data.timePer,
                        period: data.period,
                    },
                    notes: data.notes,
                })
                    .then((response) => {
                        toast.success(`Call planned!`);
                        toggleModallCallPlan();
                        reset(response);
                        setGlobalUpdate({planList: true});
                    })
                    .catch((err) => {
                        toast.error(err.response.data.message);
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            }
            
        },
        [toggleModallCallPlan, reset, currentGroup.id, toggleLoading, plan, setGlobalUpdate]
    );

    const changeOptionPlan = useCallback((event) => {
        const id = event.target.value;
        if (id) {
            setOptionSelectPlan(true);
            if (allPlans) {
                const currentPlan = allPlans.map((plan) => {
                    if (plan.receiver.id === id) {
                        return plan;
                    }
                    return false;
                });

                if (currentPlan && currentPlan.length > 0) {
                    setPlan(currentPlan[0]);
                }
            }
        } else {
            setOptionSelectPlan(false);
            setPlan(null);
        }
    }, [allPlans, setPlan, setOptionSelectPlan]);

    return (
        <Fragment>
            <Modal isOpen={modalSetupCall} toggle={toggleModalSetupCall}>
                <ModalHeader toggle={toggleModalSetupCall}>
                    Setup Call
                </ModalHeader>
                <ModalBody>
                    <div className="text-center">
                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="lg"
                            color="primary"
                            onClick={triggerScheduleCall}
                        >
                            Schedule Call
                        </Button>

                        <Button
                            className="btn-wide mb-2 mr-2"
                            size="lg"
                            color="info"
                            onClick={triggerCallPlan}
                        >
                            Call Plan
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={modalScheduleCall} toggle={toggleModalScheduleCall}>
                <ModalHeader toggle={toggleModalScheduleCall}>
                    Schedule Call
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup row>
                            <Label for="receiver" sm={2}>
                                Senior
                            </Label>
                            <Col sm={8}>
                                <select
                                    name="receiver"
                                    id="receiver"
                                    ref={register}
                                    className="form-control"
                                >
                                    {receivers &&
                                        receivers.map((receiver) => (
                                            <option
                                                value={receiver.id}
                                                key={receiver.id}
                                            >
                                                {receiver.name}
                                            </option>
                                        ))}
                                </select>
                            </Col>
                            <Col sm={2}>
                                <Button
                                    outline
                                    className="mb-2 mr-2 form-control"
                                    color="secondary"
                                    onClick={loadReceivers}
                                    disabled={isLoadingReceivers}
                                >
                                    <FontAwesomeIcon icon={faSync} spin={isLoadingReceivers} size="1x" />
                                </Button>          
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="date" sm={2}>
                                Date
                            </Label>
                            <Col sm={10}>
                                <DatePicker
                                    selected={date}
                                    onChange={toggleDate}
                                    showTimeSelect
                                    className="form-control"
                                    timeFormat="p"
                                    timeIntervals={30}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeCaption="Time"
                                    minDate={new Date()}
                                    // popperModifiers={{
                                    //     preventOverflow: {
                                    //       enabled: true,
                                    //     },
                                    //   }}
                                />
                                <div className="mt-2">
                                    <input
                                        className="mr-2"
                                        type="checkbox"
                                        onChange={(e) => {
                                            setEnabledRecurringScheduleCall(e.target.checked);
                                        }}
                                    />
                                    Repeat for the next 
                                    <select
                                        className="ml-2 mr-2"
                                        onChange={(e) => {
                                            setRecurringScheduleCallNumber(e.target.value);
                                        }}
                                    >
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                    </select>
                                    Weeks
                                </div>
                                
                            </Col>
                        </FormGroup>
                        <div className="text-center">
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="info"
                                onClick={handleSubmit(onSubmitScheduleCall)}
                            >
                                OK
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalScheduleCall}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={modallCallPlan} toggle={toggleModallCallPlan}>
                <ModalHeader toggle={toggleModallCallPlan}>
                    Call Plan
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup row>
                            <Label for="receiver" sm={2}>
                                Senior
                            </Label>
                            <Col sm={10}>
                                <select
                                    name="receiver"
                                    id="receiver"
                                    ref={register}
                                    className="form-control"
                                    onChange={changeOptionPlan}
                                >
                                    <option value="">Select</option>
                                    {receivers &&
                                        receivers.map((receiver) => (
                                            <option
                                                value={receiver.id}
                                                key={receiver.id}
                                            >
                                                {receiver.name}
                                            </option>
                                        ))}
                                </select>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="date" sm={2}>
                                Plan
                            </Label>
                            <Col sm={3}>
                                <select
                                    className="form-control"
                                    ref={register}
                                    name="plan"
                                    defaultValue={plan && plan.plan.times}
                                >
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    <option>6</option>
                                    <option>7</option>
                                </select>
                            </Col>
                            <Label sm={3}>Times per</Label>
                            <Col sm={4}>
                                <select
                                    className="form-control"
                                    ref={register}
                                    name="timePer"
                                    defaultValue={plan && plan.plan.times_per}
                                >
                                    <option>Week</option>
                                    <option>Month</option>
                                </select>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="period" sm={2}>
                                Call Period
                            </Label>
                            <Col sm={10}>
                                <select
                                    name="period"
                                    id="period"
                                    ref={register}
                                    className="form-control"
                                    defaultValue={plan && plan.plan.period}
                                >
                                    <option>Morning</option>
                                    <option>Afternoon</option>
                                    <option>Night</option>
                                </select>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="notes" sm={2}>
                                Notes
                            </Label>
                            <Col sm={10}>
                                <textarea
                                    name="notes"
                                    id="notes"
                                    ref={register}
                                    className="form-control"
                                    defaultValue={plan && plan.notes}
                                ></textarea>
                            </Col>
                        </FormGroup>
                        <div className="text-center">
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="info"
                                onClick={handleSubmit(onSubmitCallPlan)}
                                disabled={(!optionSelectPlan && !plan)}
                            >
                                OK
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModallCallPlan}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
